import { CalendarIcon } from "@xola/icons";
import { DatePickerPopover } from "@xola/ui-kit";
import { DateFormat, formatDate, JsDateRange } from "common";
import React from "react";
import { useSeller } from "../../../hooks/useAccount";

export interface DateRange extends JsDateRange {
    rangeName?: string;
}

interface CustomDateRangerPickerProps {
    value: DateRange;
    onChange: (value: JsDateRange) => void;
    disabledDays?: (date: Date) => boolean;
    isFutureDatesAllowed?: boolean;
}

export const CustomReportDateRangePicker = ({
    value,
    onChange,
    disabledDays,
    isFutureDatesAllowed = true,
}: CustomDateRangerPickerProps) => {
    const { timezoneName } = useSeller();

    return (
        <div>
            <DatePickerPopover
                shouldShowYearPicker
                shouldShowRelativeRanges
                isFutureDatesAllowed={isFutureDatesAllowed}
                variant="range"
                value={value}
                timezoneName={timezoneName}
                popoverProps={{ placement: "bottom-end", distance: 8 }}
                disabledDays={disabledDays}
                onChange={onChange}
            >
                <div className="flex h-10 w-full cursor-pointer items-center rounded border border-gray-light p-3">
                    <CalendarIcon className="mr-1" size="medium" />
                    <span className="truncate">
                        {value.from ? formatDate(value.from, DateFormat.DATE) : "Pending"}
                        &nbsp;-&nbsp;
                        {value.to ? formatDate(value.to, DateFormat.DATE) : "Pending"}
                    </span>
                </div>
            </DatePickerPopover>
        </div>
    );
};
